// Closes the fail-open hole that route splitting opens.

const CHUNK_ERROR_PATTERNS = [
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /unable to preload css/i,
  /importing a module script failed/i,
];

export const isChunkLoadError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : '';
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message));
};

interface ChunkFailureDeps {
  armRenderProbe: (now: number) => void;
  now: () => number;
}

// Error instances already armed for this page load.
// Dedup by Error identity: vite:preloadError and componentDidCatch both see the same Error, and
// without this the threshold of 3 would act as 2.
const armedFailures = new WeakSet<Error>();

export const reportChunkFailure = (deps: ChunkFailureDeps, error: unknown): boolean => {
  if (!isChunkLoadError(error)) return false;
  const key = error as Error;
  if (armedFailures.has(key)) return true;
  armedFailures.add(key);
  deps.armRenderProbe(deps.now());
  return true;
};
